import { isDev } from '../util';

export const getDevLang = () => (isDev() ? 'zh' : import.meta.env.VITE_APP_LANG);

/**
 * 获取开发环境Token
 
 * @returns {string} Bearer token
 */
export const getDevToken = () => {
  const customToken = sessionStorage.getItem('devToken');
  return customToken
    ? `Bearer ${customToken}`
    : `Bearer eyJhbGciOiJIUzUxMiJ9.eyJjcmVhdGVkVGltZSI6MTc4Nzc5NTc3MTMwMywiY2xpZW50IjoiQ3JlZml0IiwibGlua1R5cGUiOiIiLCJ1c2VySWQiOiIxNTExMTk4In0.5ik7JpPIf4eNmQ_Zm8Vb7S79o2i0IF53WQRq4OHSOu_w-bnT_jsmE2JVHSTuxdiE19dewr9fa_HTXTc4Ku2iTg`;
};

export const getDevIsUIv2 = () =>
  isDev() ? true : import.meta.env.VITE_APP_NEW_VERSION === 'true';
